// extracted by mini-css-extract-plugin
export default {"container":"Wl-z","blurb":"Xl-z","links":"Yl-z"};